import request from "./request";

// 菜单信息
export const getMenu = (params?: any) =>
    request({
        url: "/menu",
        method: "get",
        params
    })

// 权限列表-选项数据
export const getMenuList = (params: any) =>
    request({
        url: "/basis/authMenu/form",
        method: "get",
        params
    })

// 权限菜单-菜单列表
export const getALlMenuList = () =>
    request({
        url: "/basis/authMenu/list",
        method: "get"
    })

// 获取菜单的详细信息
export const getSingleMenuMsg = (params: any) =>
    request({
        url: "/basis/authMenu/info",
        method: "get",
        params
    })

// 添加权限菜单
export const addPermissionMenu = (data: any) =>
    request({
        url: "/basis/authMenu/add",
        method: "post",
        data
    })

// 修改权限菜单
export const editPermissionMenu = (data: any) =>
    request({
        url: "/basis/authMenu/set",
        method: "post",
        data
    })

// 删除权限菜单
export const deletePermissionMenu = (data: any) =>
    request({
        url: "/basis/authMenu/del",
        method: "post",
        data
    })

// 修改菜单状态
export const editMenuStatus = (data: any) =>
    request({
        url: "/basis/authMenu/setStatus",
        method: "post",
        data
    })


/* 角色接口 */

// 获取角色选项数据
export const getRolesData = (params: any) =>
    request({
        url: "/basis/authRole/form",
        method: "get",
        params
    })

// 添加角色
export const addRole = (data: any) =>
    request({
        url: "/basis/authRole/add",
        method: "post",
        data
    })

// 获取角色列表
export const getRoleList = (params: any) =>
    request({
        url: "/basis/authRole/list",
        method: "get",
        params
    })

// 获取单个角色信息
export const getRoleMsg = (params: any) =>
    request({
        url: "/basis/authRole/info",
        method: "get",
        params
    })

// 修改角色信息
export const editRoleMsg = (data: any) =>
    request({
        url: "/basis/authRole/set",
        method: "post",
        data
    })

// 删除角色信息
export const delRoleMsg = (data: any) =>
    request({
        url: "/basis/authRole/del",
        method: "post",
        data
    })

// 修改角色状态
export const editRoleStatus = (data: any) =>
    request({
        url: "/basis/authRole/setStatus",
        method: "post",
        data
    })

/*管理员接口*/

// 管理员列表
export const getManageList = (params: any) =>
    request({
        url: "/basis/authUser/list",
        method: "get",
        params
    })

// 管理员添加
export const addManageUser = (data: any) =>
    request({
        url: "/basis/authUser/add",
        method: "post",
        data
    })

// 管理员修改
export const editManageUser = (data: any) =>
    request({
        url: "/basis/authUser/set",
        method: "post",
        data
    })

// 管理员删除
export const delManageUser = (data: any) =>
    request({
        url: "/basis/authUser/del",
        method: "post",
        data
    })

// 管理员信息
export const manageUserMsg = (params: any) =>
    request({
        url: "/basis/authUser/info",
        method: "get",
        params
    })

// 修改管理员状态
export const editManStatus = (data: any) =>
    request({
        url: "/basis/authUser/setStatus",
        method: "post",
        data
    })

// 修改管理员密码
export const changeManPwd = (data: any) =>
    request({
        url: "/basis/authUser/setPwd",
        method: "post",
        data
    })

// 短信通知
export const getMessageSms = (params: any) =>
    request({
        url: "/market/messageLog/sms",
        method: "get",
        params
    })

// 订单消息
export const getMessageOrder = (params: any) =>
    request({
        url: "/market/messageLog/order",
        method: "get",
        params
    })

// 站内信
export const getMessageMail = (params: any) =>
    request({
        url: "/market/messageLog/mail",
        method: "get",
        params
    })

// 通知中心-选项数据
export const getNoticeOptions = (params?: any) =>
    request({
        url: "/basis/sysMessage/form",
        method: "get",
        params
    })

// 通知中心-通知列表
export const getNoticeList = (params?: any) =>
    request({
        url: "/message",
        method: "get",
        params
    })

// 通知中心-消息已读
export const readNotice = (data: any) =>
    request({
        url: "/basis/sysMessage/messageRead",
        method: "post",
        data
    })
//通知中心- 未读
export const unReadNum = () =>
    request({
        url: "/messageUnReadCnt",
        method: "get",
    })

//通知中心-设置已读
export const setRead = (data: any) =>
    request({
        url: "/messageSetRead",
        method: "post",
        data
    })

// 通知中心-全部消息已读
export const readAllNotice = (data?: any) =>
    request({
        url: "/basis/sysMessage/messageReadAll",
        method: "post",
        data
    })

// 修改个人信息
export const setPersonalInfo = (data: any) =>
    request({
        url: "/setInfo",
        method: "POST",
        data
    })

// 修改个人密码
export const setPersonalPwd = (data: any) =>
    request({
        url: "/setPwd",
        method: "POST",
        data
    })

/*
 * 地址数据接口
*/

// 省份
export const getProvice = (params?: any) =>
    request({
        url: "/province",
        method: "get",
        params
    })

// 城市
export const getCity = (params?: any) =>
    request({
        url: "/city",
        method: "get",
        params
    })

// 区域
export const getArea = (params?: any) =>
    request({
        url: "/area",
        method: "get",
        params
    })

// 应用初始化
export const init = (data: any) =>
    request({
        url: '/init',
        method: 'post',
        data
    })

/**
 * 帮助中心文章相关接口
 */
//文章列表
export const getArticles = (params?: any) =>
    request({
        url: '/basis/article/list',
        method: 'get',
        params
    })
//文章分类列表
export const getArtCategory = () =>
    request({
        url: '/basis/article/categoryList',
        method: 'get'
    })
//删除文章分类
export const delCategory = (data: any) =>
    request({
        url: '/basis/article/categoryDel',
        method: 'post',
        data
    })
//添加文章分类
export const addCategory = (data: any) =>
    request({
        url: '/basis/article/categoryAdd',
        method: 'post',
        data
    })
//修改文章分类
export const modifyCategory = (data: any) =>
    request({
        url: '/basis/article/categorySet',
        method: 'post',
        data
    })
//新增文章
export const addArticle = (data: any) =>
    request({
        url: '/basis/article/add',
        method: 'post',
        data
    })
//修改文章
export const modifyArticle = (data: any) =>
    request({
        url: '/basis/article/set',
        method: 'post',
        data
    })
//删除文章
export const delArticle = (data: any) =>
    request({
        url: '/basis/article/del',
        method: 'post',
        data
    })
//获取文章详情
export const getArticleDetails = (params: any) =>
    request({
        url: '/basis/article/info',
        method: 'get',
        params
    })
// 白名单-白名单列表
export const getWhiteList = (params?: any) =>
    request({
        url: '/basis/sysWhite/list',
        method: 'get',
        params
    })
// 白名单-选项数据
export const getWhiteListOptions = (params?: any) =>
    request({
        url: '/basis/sysWhite/form',
        method: 'get',
        params
    })
// 白名单-查找账号
export const findMember = (params?: any) =>
    request({
        url: '/member/search',
        method: 'get',
        params
    })
// 白名单-添加白名单
export const addWhiteList = (data: any) =>
    request({
        url: '/basis/sysWhite/add',
        method: 'POST',
        data
    })
// 白名单-修改白名单
export const setWhiteList = (data: any) =>
    request({
        url: '/basis/sysWhite/setStatus',
        method: 'POST',
        data
    })
// 白名单-删除白名单
export const delWhiteList = (data: any) =>
    request({
        url: '/basis/sysWhite/del',
        method: 'POST',
        data
    })

// 客服管理-客服列表
export const getCustomerList = (params: any) =>
    request({
        url: '/basis/sysCustomer/list',
        method: 'GET',
        params
    })

// 客服管理-客服信息
export const getCustomerInfo = (params: { id: number }) =>
    request({
        url: '/basis/sysCustomer/info',
        method: 'GET',
        params
    })

// 客服管理-管理员列表
export const getCustomerManagers = (params?: any) =>
    request({
        url: '/basis/sysCustomer/auth',
        method: 'GET',
        params
    })

// 客服管理-官方达人列表
export const getCustomerOfficial = (params: { id: number }) =>
    request({
        url: '/basis/sysCustomer/official',
        method: 'POST',
        params
    })

// 客服管理-添加客服
export const addCustomers = (data: any) =>
    request({
        url: '/basis/sysCustomer/add',
        method: 'POST',
        data
    })

// 客服管理-获取二维码链接
export const getCustomerQrcode = (params: { id: number }) =>
    request({
        url: '/basis/sysCustomer/qrcode',
        method: 'GET',
        params
    })

// 客服管理-编辑客服
export const editCustomers = (data: any) =>
    request({
        url: '/basis/sysCustomer/set',
        method: 'POST',
        data
    })

// 客服管理-删除客服
export const delCustomer = (data: { id: number }) =>
    request({
        url: '/basis/sysCustomer/del',
        method: 'POST',
        data
    })

// 客服管理-客服绑定状态
export const getCustomerStatus = (params: { id: number }) =>
    request({
        url: '/basis/sysCustomer/customerStatus',
        method: 'GET',
        params
    })

// 首页数据
export const getMains = (params?: any) =>
    request({
        url: "/main",
        method: "get",
        params
    })

// 首页会员数据
export const getMemberData = (params?: any) =>
    request({
        url: "/memberData",
        method: "get",
        params
    })
//数据中心-流量分析-流量趋势
export const getDataFlow = (params?: any) =>
    request({
        url: "/data/member/flow",
        method: "get",
        params
    })
//数据中心-流量分析-流量分布
export const getTrafficDate = (params?: any) =>
    request({
        url: "/data/member/flowDistribution",
        method: "get",
        params
    })
//数据中心-交易分析
export const getTradeTrend = (params?: any) =>
    request({
        url: "/data/order/trend",
        method: "get",
        params
    })
//数据中心-用户分析-用户概況及趋势
export const getUserTrend = (params?: any) =>
    request({
        url: "/data/member/trend",
        method: "get",
        params
    })
//数据中心-服务分析-服务总览
export const getSkillTotal = (params?: any) =>
    request({
        url: "/data/skill/total",
        method: "get",
        params
    })
//数据中心-服务分析-服务排行榜
export const getSkillRank = (params?: any) =>
    request({
        url: "/data/skill/ranking",
        method: "get",
        params
    })
//数据中心-数据概况-服务总览
export const getTotalMain = (params?: any) =>
    request({
        url: "/data/total/main",
        method: "get",
        params
    })
//数据中心-数据概况-运营视窗
export const getTotalOperate = (params?: any) =>
    request({
        url: "/data/total/operate",
        method: "get",
        params
    })

// 操作日志-选项数据（会员）
export const getMemberOptions = (params?: any) =>
    request({
        url: "/basis/logs/memberForm",
        method: "get",
        params
    })

// 操作日志-列表（会员）
export const getMemberLogs = (params?: any) =>
    request({
        url: "/basis/logs/member",
        method: "get",
        params
    })


// 操作日志-选项数据（员工）
export const getOperationForm = (params?: any) =>
    request({
        url: "/basis/logs/operationForm",
        method: "get",
        params
    })

// 操作日志-列表（员工）
export const getOperationLogs = (params?: any) =>
    request({
        url: "/basis/logs/operation",
        method: "get",
        params
    })

// 重要操作日志-选项数据
export const getsensitiveForm = (params?: any) =>
    request({
        url: "/basis/logs/sensitiveForm",
        method: "get",
        params
    })

// 重要操作日志-列表
export const getSensitiveLogs = (params?: any) =>
    request({
        url: "/basis/logs/sensitive",
        method: "get",
        params
    })

/*
 用户部分
*/

// socket 绑定用户
export const bindUser = (data: any) =>
    request({
        url: "/im/bind",
        method: "POST",
        data
    })

// 登录
export const login = (data: any) =>
    request({
        url: "/login",
        method: "post",
        data
    });

// 退出登录
export const logout = () =>
    request({
        url: '/loginOut',
        method: 'post'
    })

// 获取个人信息
export const getUserInfo = (params?: any) =>
    request({
        url: "/info",
        method: "get",
        params
    });

/*
   订单部分
*/

// 订单列表-搜索
export const orderSearch = (params: any) =>
    request({
        url: "/order/searchInfo",
        method: "get",
        params
    });


// 订单列表
export const getOrderList = (params: any) =>
    request({
        url: "/order/list",
        method: "get",
        params
    });

// 订单详情
export const getOrderDetail = (params: any) =>
    request({
        url: "/order/info",
        method: "get",
        params
    });

// 取消订单
export const cancleOrder = (data: any) =>
    request({
        url: "/order/cancel",
        method: "post",
        data
    });

// 拒绝接单
export const refruseOrder = (data: any) =>
    request({
        url: "/order/refuse",
        method: "post",
        data
    });

// 立即接单
export const receiveOrder = (params: any) =>
    request({
        url: "/order/receipt",
        method: "get",
        params
    });

// 退款详情
export const refundDetail = (params: any) =>
    request({
        url: "/order/refund/info",
        method: "get",
        params
    });

// 退款审核
export const refundCheck = (data: any) =>
    request({
        url: "/order/refund/check",
        method: "post",
        data
    });

// 服务完成
export const finishOrder = (data: any) =>
    request({
        url: "/order/finish",
        method: "post",
        data
    });

// 退款
export const refundOrder = (data: any) =>
    request({
        url: "/order/refund",
        method: "post",
        data
    });

// 申诉列表
export const applyList = (params: any) =>
    request({
        url: "/order/appeal/list",
        method: "get",
        params
    });

// 申诉详情
export const applyDetail = (params: any) =>
    request({
        url: "/order/appeal/info",
        method: "get",
        params
    });

// 申诉处理
export const applyDeal = (data: any) =>
    request({
        url: "/order/appeal/check",
        method: "post",
        data
    });

/* 优惠券 */

// 优惠券列表
export const discountList = (params: any) =>
    request({
        url: "/market/coupon/list",
        method: "post",
        params
    });

// 领取优惠券/使用优惠券
export const getDiscounts = (params: any) =>
    request({
        url: "/market/coupon/sendList",
        method: "get",
        params
    });

// 添加优惠券
export const addDiscount = (data: any) =>
    request({
        url: "/market/coupon/add",
        method: "post",
        data
    });

// 添加/编辑优惠券-技能列表
export const discountSkills = (params: any) =>
    request({
        url: "/market/coupon/form",
        method: "post",
        params
    });

// 优惠券详情
export const discountDetail = (params: any) =>
    request({
        url: "/market/coupon/info",
        method: "get",
        params
    });

// 编辑优惠券
export const editDiscount = (data: any) =>
    request({
        url: "/market/coupon/set",
        method: "post",
        data
    });

// 删除优惠券
export const delDiscount = (data: any) =>
    request({
        url: "/market/coupon/del",
        method: "post",
        data
    });

/* 运营部分 */
// 标签列表
export const getLabels = (params?: any) =>
    request({
        url: "/market/tag/list",
        method: "get",
        params
    });

// 标签管理-选项数据
export const getLabelOptions = (params: any) =>
    request({
        url: "/market/tag/form",
        method: "get",
        params
    });

// 标签/用户分群-服务或标签列表
export const getLabelOrServes = (params?: any) =>
    request({
        url: "/market/tag/choose",
        method: "get",
        params
    });

// 添加标签
export const addLabels = (data: any) =>
    request({
        url: "/market/tag/add",
        method: "post",
        data
    });

// 编辑标签
export const setLabels = (data: any) =>
    request({
        url: "/market/tag/set",
        method: "post",
        data
    });

// 删除标签
export const delLabels = (data: any) =>
    request({
        url: "/market/tag/del",
        method: "post",
        data
    });

// 运营计划-计划列表
export const getPlanList = (params?: any) =>
    request({
        url: "/market/plan/list",
        method: "get",
        params
    });

// 运营计划-添加计划
export const addPlan = (data: any) =>
    request({
        url: "/market/plan/add",
        method: "post",
        data
    });

// 运营计划-计划详情
export const getPlanInfo = (params?: any) =>
    request({
        url: "/market/plan/info",
        method: "get",
        params
    });

// 运营计划-编辑计划
export const editPlan = (data: any) =>
    request({
        url: "/market/plan/set",
        method: "post",
        data
    });

// 运营计划-删除计划
export const delPlan = (data: any) =>
    request({
        url: "/market/plan/del",
        method: "post",
        data
    });

// 运营计划-统计计划
export const cenPlan = (params: any) =>
    request({
        url: "/market/plan/census",
        method: "get",
        params
    });

// 用户分群
export const getCrowdList = (params?: any) =>
    request({
        url: "/market/crowd/list",
        method: "get",
        params
    })

// 用户分群选项数据
export const getCrowdOptions = (params?: any) =>
    request({
        url: "/market/crowd/form",
        method: "get",
        params
    })

// 添加分群
export const addCrowd = (data: any) =>
    request({
        url: "/market/crowd/add",
        method: "post",
        data
    });

// 编辑分群
export const setCrowd = (data: any) =>
    request({
        url: "/market/crowd/set",
        method: "post",
        data
    });

// 删除分群
export const delCrowd = (data: any) =>
    request({
        url: "/market/crowd/del",
        method: "post",
        data
    });


/*
   财务部分
*/
// 选项数据
export const getAccountOptions = (params?: any) =>
    request({
        url: "/trade/gold/rechargeForm",
        method: "get",
        params
    });


// 资金充值-选项数据
export const getAccountInfo = (params?: any) =>
    request({
        url: "/trade/amount/accountInfo",
        method: "get",
        params
    });

// 资金充值
export const recharge = (data: any) =>
    request({
        url: "/trade/gold/recharge",
        method: "post",
        data
    });

// 资金交易记录 - 选项数据
export const getTradeLogsFrom = (params?: any) =>
    request({
        url: "/trade/amount/logsForm",
        method: "get",
        params
    });

// 资金明细
export const getTradeLogs = (params?: any) =>
    request({
        url: "/trade/amount/logs",
        method: "get",
        params
    });

// 资金充值明细
export const getAmountRechargeLogs = (params?: any) =>
    request({
        url: "/trade/amount/rechargeLogs",
        method: "get",
        params
    });

// 创意币明细
export const getGoldLogs = (params?: any) =>
    request({
        url: "/trade/gold/logs",
        method: "get",
        params
    });

// 创意币充值记录
export const getRechargeLogs = (params?: any) =>
    request({
        url: "/trade/gold/rechargeLogs",
        method: "get",
        params
    });

// 获取结算记录
export const getSettlementList = (params?: any) =>
    request({
        url: "/trade/amount/settle",
        method: "get",
        params
    });

// 立即结算
export const submitSettlement = (data: any) =>
    request({
        url: "/trade/amount/confirm",
        method: "post",
        data
    });

// 提现管理 - 选项数据
export const getWithdrawOptions = (params?: any) =>
    request({
        url: "/member/withdraw/form",
        method: "get",
        params
    });

// 提现管理-提现列表
export const getWithdrawList = (params?: any) =>
    request({
        url: "/member/withdraw/list",
        method: "get",
        params
    });

// 提现管理-统计
export const getStatistics = (params?: any) =>
    request({
        url: "/member/withdraw/total",
        method: "get",
        params
    });

// 提现管理-提现详情
export const getWithdrawInfo = (params?: any) =>
    request({
        url: "/member/withdraw/info",
        method: "get",
        params
    });

//提现管理 - 提现绑定
export const getWithdrawal = (data?: any) =>
    request({
        url: "/member/withdraw/rebindAlipay",
        method: "POST",
        data
    });
/*
   服务管理
*/

// 添加服务
export const addSkillForm = (data: any) =>
    request({
        url: "/market/skill/add",
        method: "post",
        data
    });

// 修改服务
export const setSkillForm = (data: any) =>
    request({
        url: "/market/skill/set",
        method: "post",
        data
    });

export const setSkillSetFields = (data: any) =>
    request({
        url: "/market/skill/setFields",
        method: "post",
        data
    });

export const setSkillStatus = (data: any) =>
    request({
        url: "/market/skill/setStatus",
        method: "post",
        data
    });

export const delSkill = (data: any) =>
    request({
        url: "/market/skill/del",
        method: "post",
        data
    });

// 获取服务选项数据
export const getSkillOptions = (params?: any) =>
    request({
        url: "/market/skill/form",
        method: "get",
        params
    });

// 获取服务选项数据
export const getSkillInfo = (params?: any) =>
    request({
        url: "/market/skill/info",
        method: "get",
        params
    });

// 获取服务选项数据
export const getSkillFields = (params?: any) =>
    request({
        url: "/market/skill/setFieldsShow",
        method: "get",
        params
    });

// 获取服务
export const getSkillList = (params?: any) =>
    request({
        url: "/market/skill/list",
        method: "get",
        params
    });

/*
   系统设置
*/

// APP版本列表
export const getVersionList = (params?: any) =>
    request({
        url: "/basis/app/versionList",
        method: "get",
        params
    });
// 添加APP版本
export const addVersion = (data?: any) =>
    request({
        url: "/basis/app/versionAdd",
        method: "post",
        data
    });

// 	分块上传
// export const uploadChunks = process.env.VUE_APP_BASE_API + '/upload/chunks';
export const uploadChunks = '/upload/chunks';

// APP版本信息
export const getVersionInfo = (params?: any) =>
    request({
        url: "/basis/app/versionInfo",
        method: "get",
        params
    });

// 编辑APP版本
export const setVersion = (data?: any) =>
    request({
        url: "/basis/app/versionSet",
        method: "post",
        data
    });

// 删除APP版本
export const delVersion = (data?: any) =>
    request({
        url: "/basis/app/versionDel",
        method: "post",
        data
    });

// 修改APP版本上线状态
export const setVersionStatus = (data?: any) =>
    request({
        url: "/basis/app/versionSetStatus",
        method: "post",
        data
    });

// 系统配置-配置信息
export const getSysSettingInfo = (params: any) =>
    request({
        url: params.url,
        method: "get",
    });

// 系统配置-修改配置
export const changeConfig = (data: any) =>
    request({
        url: data.url,
        method: "post",
        data: data.params
    });

// 添加敏感词
export const addSensitive = (data?: any) =>
    request({
        url: "/market/sensitive/add",
        method: "post",
        data
    });

// 敏感词列表
export const getSensitiveList = (params?: any) =>
    request({
        url: "/market/sensitive/list",
        method: "get",
        params
    });

// 编辑敏感词
export const setSensitive = (data?: any) =>
    request({
        url: "/market/sensitive/set",
        method: "post",
        data
    });

// 删除敏感词
export const delSensitive = (data?: any) =>
    request({
        url: "/market/sensitive/del",
        method: "post",
        data
    });

// 禁用/启用敏感词汇
export const setSensitiveStatus = (data?: any) =>
    request({
        url: "/market/sensitive/setStatus",
        method: "post",
        data
    });

// 敏感词触发记录
export const getSensitiveRecord = (params?: any) =>
    request({
        url: "/market/sensitive/hit",
        method: "get",
        params
    });

// 敏感词排行
export const getSensitiveRank = (params?: any) =>
    request({
        url: "/market/sensitive/rank",
        method: "get",
        params
    });


// 话题分类列表
export const getTopicCates = (params?: any) =>
    request({
        url: "/market/topicCategory/list",
        method: "get",
        params
    });

// 添加话题分类
export const addTopicCates = (data: any) =>
    request({
        url: "/market/topicCategory/add",
        method: "post",
        data
    });

// 编辑话题分类
export const editTopicCates = (data: any) =>
    request({
        url: "/market/topicCategory/set",
        method: "post",
        data
    });

// 删除话题分类
export const delTopicCates = (data: any) =>
    request({
        url: "/market/topicCategory/del",
        method: "post",
        data
    });

// 禁用/启用话题分类
export const setStatusTopicCates = (data: any) =>
    request({
        url: "/market/topicCategory/setStatus",
        method: "post",
        data
    });

// 话题列表
export const getTopicLists = (params?: any) =>
    request({
        url: "/market/topic/list",
        method: "get",
        params
    });

// 添加话题
export const addTopic = (data: any) =>
    request({
        url: "/market/topic/add",
        method: "post",
        data
    });

// 编辑话题
export const editTopic = (data: any) =>
    request({
        url: "/market/topic/set",
        method: "post",
        data
    });

// 删除话题
export const delTopic = (data: any) =>
    request({
        url: "/market/topic/del",
        method: "post",
        data
    });

// 启用/禁用话题
export const setStatusTopic = (data: any) =>
    request({
        url: "/market/topic/setStatus",
        method: "post",
        data
    });

// 修改推荐状态
export const changeRecommendstatus = (data: any) =>
    request({
        url: "/market/topic/setRecommend",
        method: "post",
        data
    });

// 话题-话题分类
export const getTopicCateData = (params?: any) =>
    request({
        url: "/market/topic/category",
        method: "get",
        params
    });

// 动态列表
export const getTrendsList = (params?: any) =>
    request({
        url: "/member/trends/list",
        method: "get",
        params
    });

// 动态详情
export const getTrendsInfo = (params: any) =>
    request({
        url: "/member/trends/info",
        method: "get",
        params
    });

// 删除动态
export const delTrend = (data: any) =>
    request({
        url: "/member/trends/del",
        method: "post",
        data
    });

// 批量删除动态
export const delTrendList = (data: any) =>
    request({
        url: "/member/trends/batchDel",
        method: "post",
        data
    });

// 动态评论列表
export const getCommentList = (params?: any) =>
    request({
        url: "/member/comment/list",
        method: "get",
        params
    });

// 动态评论详情
export const getCommentInfo = (params: any) =>
    request({
        url: "/member/comment/info",
        method: "get",
        params
    });

// 删除评论
export const delComment = (data: any) =>
    request({
        url: "/member/comment/del",
        method: "POST",
        data
    });

// 批量删除评论
export const delMoreComment = (data: any) =>
    request({
        url: "/member/comment/batchDel",
        method: "POST",
        data
    });

// 合作需求-需求列表
export const getDemandList = (params?: any) =>
    request({
        url: "/member/demand/list",
        method: "get",
        params
    });

// 合作需求-需求详情
export const getDemandInfo = (params: any) =>
    request({
        url: "/member/demand/info",
        method: "get",
        params
    });

// 合作需求-删除需求
export const delDemands = (data: any) =>
    request({
        url: "/member/demand/del",
        method: "POST",
        data
    });

// 合作需求-批量删除
export const delDemandToBatch = (data: any) =>
    request({
        url: "/member/demand/batchDel",
        method: "POST",
        data
    });

/*
*   用户管理
*/
// 会员管理-会员列表
export const getMemberList = (params?: any) =>
    request({
        url: "/member/list",
        method: "get",
        params
    });

// 会员管理-会员信息
export const getMemberInfo = (params?: any) =>
    request({
        url: "/member/info",
        method: "get",
        params
    });

// 会员管理-提现状态
export const delWithdrawal = (data: any) =>
    request({
        url: "/member/withdraw/setAllowStatus",
        method: "POST",
        data
    });

// 会员管理-协议签署状态
export const setSignProtocol = (data: any) =>
    request({
        url: "/member/withdraw/setSignProtocol",
        method: "POST",
        data
    });

// 会员管理-获取用户标签
export const getUserTags = (params: any) =>
    request({
        url: "/member/tag/label",
        method: "get",
        params
    });

// 会员管理-修改会员状态
export const setMemberStatus = (data: any) =>
    request({
        url: "/member/setStatus",
        method: "post",
        data
    });
// 会员管理-修改提现押金
export const setMemberWD = (data: any) =>
    request({
        url: "/member/setWD",
        method: "post",
        data
    });

// 会员管理-修改会员密码
export const setMemberPwd = (data: any) =>
    request({
        url: "/member/setPwd",
        method: "post",
        data
    });

// 会员管理-修改会员信息
export const setMemberInfo = (data: any) =>
    request({
        url: "/member/setInfo",
        method: "post",
        data
    });

//会员管理-选项数据
export const getOptionsData = (params?: any) =>
    request({
        url: "/member/form",
        method: "get",
        params
    });

// 会员管理-会员登录日志(选项数据)
export const getLoginLogsForm = (params?: any) =>
    request({
        url: "/member/loginLogsForm",
        method: "GET",
        params
    })

// 会员管理-会员登录日志
export const getLoginLogs = (params: any) =>
    request({
        url: "/member/loginLogs",
        method: "GET",
        params
    })

// 会员管理-会员启动日志（选项数据）
export const getStartupLogsForm = (params?: any) =>
    request({
        url: "/member/startupLogsForm",
        method: "GET",
        params
    })

// 会员管理-会员启动日志
export const getStartupLogs = (params?: any) =>
    request({
        url: "/member/startupLogs",
        method: "GET",
        params
    })

// 会员管理-黑名单列表
export const getBlackList = (params?: any) =>
    request({
        url: "/member/ban",
        method: "GET",
        params
    })

// 会员管理-移除黑名单
export const delBlackList = (data: any) =>
    request({
        url: "/member/removeBan",
        method: "POST",
        data
    })

// 会员管理-设置用户备注
export const setRemark = (data: any) =>
    request({
        url: "/member/setRemark",
        method: "POST",
        data
    })

// 会员管理-冻结账号（选项信息）
export const frozensOptions = (params?: any) =>
    request({
        url: "/member/frozen/form",
        method: "GET",
        params
    })

// 会员管理-冻结账号
export const frozenUser = (data: any) =>
    request({
        url: "/member/frozen/add",
        method: "POST",
        data
    })

// 会员管理-取消冻结
export const cancleFrozen = (data: any) =>
    request({
        url: "/member/frozen/cancel",
        method: "POST",
        data
    })

// 会员管理-用户财务数据-选项数据
export const getMemberTradeForm = (params: any) =>
    request({
        url: "/member/tradeForm",
        method: "GET",
        params
    })

// 会员管理-用户财务数据
export const getMemberTrade = (params: any) =>
    request({
        url: "/member/trade",
        method: "GET",
        params
    })

// 会员管理-用户动态数据
export const getMemberTrends = (params: any) =>
    request({
        url: "/member/trends",
        method: "GET",
        params
    })

// 会员管理-键入敏感词（选项数据）
export const getMemberSensitiveForm = (params: any) =>
    request({
        url: "/member/sensitiveForm",
        method: "GET",
        params
    })

// 会员管理-用户键入敏感词记录
export const getMemberSensitives = (params: any) =>
    request({
        url: "/member/sensitive",
        method: "GET",
        params
    })

// 会员管理-用户反馈
export const getMemberFeedBack = (params: any) =>
    request({
        url: "/member/feedback",
        method: "GET",
        params
    })

// 会员管理-操作日志（选项信息）
export const getMemberLogForm = (params?: any) =>
    request({
        url: "/member/operationForm",
        method: "GET",
        params
    })

// 会员管理-操作日志
export const getLogsFromMember = (params?: any) =>
    request({
        url: "/member/operation",
        method: "GET",
        params
    })
//会员管理-商家绑定
export const getMerchantBinding = (params?: any) =>
    request({
        url: "/seller/bindList",
        method: "GET",
        params
    })
//商家绑定-选项数据
export const getDataOption = (params?: any) =>
    request({
        url: "/seller/bindForm",
        method: "GET",
        params
    })

// 服务认证 - 选项数据
export const getMemberSkillForm = (params?: any) =>
    request({
        url: "/member/skillModify/form",
        method: "get",
        params
    });

// 服务认证 - 列表
export const getMemberSkillList = (params?: any) =>
    request({
        url: "/member/skillModify/list",
        method: "get",
        params
    });

export const getChangeBinding = (data?: any) =>
    request({
        url: "/seller/rebindStaff",
        method: "POST",
        data
    });

// 服务认证信息
export const getMemberSkillInfo = (params?: any) =>
    request({
        url: "/member/skillModify/info",
        method: "get",
        params
    });

// 服务认证信息-粉丝数量
export const getSkillFans = (params?: any) =>
    request({
        url: "/member/skillModify/fans",
        method: "get",
        params
    });

// 服务认证审核
export const memberSkillCheck = (data?: any) =>
    request({
        url: "/member/skillModify/check",
        method: "post",
        data
    });

// 认证管理-实名认证
export const getMemberRealAuth = (params?: any) =>
    request({
        url: "/member/realAuth",
        method: "get",
        params
    });

// 实名资料认证-列表
export const getMemberIdentityAuth = (params?: any) =>
    request({
        url: "/member/identityAuth",
        method: "get",
        params
    });

// 实名资料认证-详情
export const getMemberIdentityInfo = (params?: any) =>
    request({
        url: "/member/identityInfo",
        method: "get",
        params
    });

// 实名资料认证-审核认证
export const checkIdentity = (data?: any) =>
    request({
        url: "/member/checkIdentity",
        method: "post",
        data
    });

// 举报管理-表单选项数据
export const getReportFrom = (params?: any) =>
    request({
        url: "/order/report/form",
        method: "get",
        params
    });

// 举报管理-举报列表
export const getReportList = (params?: any) =>
    request({
        url: "/order/report/list",
        method: "get",
        params
    });

// 举报管理-举报详情
export const getReportInfo = (params?: any) =>
    request({
        url: "/order/report/info",
        method: "get",
        params
    });

// 举报管理-回复举报
export const answerReport = (data: any) =>
    request({
        url: "/order/report/apply",
        method: "POST",
        data
    })

// 举报管理-冻结账号
export const frozenUserOfOrder = (data: any) =>
    request({
        url: "/order/report/frozen",
        method: "POST",
        data
    })

// 修改认证服务审核 - 选项数据
export const getSkillModifyFrom = (params?: any) =>
    request({
        url: "/member/skillModify/form",
        method: "get",
        params
    });

// 修改认证服务审核 - 审核列表
export const getSkillModifyList = (params?: any) =>
    request({
        url: "/member/skillModify/list",
        method: "get",
        params
    });

// 修改认证服务审核 - 认证信息
export const getSkillModifyInfo = (params?: any) =>
    request({
        url: "/member/skillModify/info",
        method: "get",
        params
    });

// 修改认证服务审核 - 审核信息
export const checkSkillModify = (data?: any) =>
    request({
        url: "/member/skillModify/check",
        method: "post",
        data
    });

// 修改个人资料 - 选项数据
export const getInfoModifyFrom = (params?: any) =>
    request({
        url: "/member/infoModify/form",
        method: "get",
        params
    });

// 修改个人资料 - 列表数据
export const getInfoModifyList = (params?: any) =>
    request({
        url: "/member/infoModify/list",
        method: "get",
        params
    });

// 修改个人资料 - 认证信息
export const getInfoModifyInfo = (params?: any) =>
    request({
        url: "/member/infoModify/info",
        method: "get",
        params
    });

// 修改个人资料 - 审核认证信息
export const checkInfoModify = (data?: any) =>
    request({
        url: "/member/infoModify/check",
        method: "post",
        data
    });

// 用户反馈 - 列表/详情
export const getFeedBack = (params?: any) =>
    request({
        url: "/member/feedback/list",
        method: "GET",
        params
    })

export const replyFeedBack = (data: any) =>
    request({
        url: "/member/feedback/reply",
        method: "POST",
        data
    })
export const getFeedBackOptions = (params?: any) =>
    request({
        url: "/member/feedback/form",
        method: "GET",
        params
    })
/*
 * 接单系统
*/
// 官方达人列表
export const getOfficalList = (params?: any) =>
    request({
        url: "/member/official/list",
        method: "GET",
        params
    })

// 批量创建达人
export const createMoreMember = (data: any) =>
    request({
        url: "/member/official/create",
        method: "POST",
        data
    })

// 创建单个达人
export const createMember = (data: any) =>
    request({
        url: "/member/official/add",
        method: "POST",
        data
    })

// 置顶达人
export const setOfficalTop = (data: any) =>
    request({
        url: "/member/official/top",
        method: "POST",
        data
    })

// 删除达人聊天
export const delCurrentChat = (data: any) =>
    request({
        url: "/member/official/hidden",
        method: "POST",
        data
    })

// 官方达人-选项数据
export const getOfficalOptions = (params?: any) =>
    request({
        url: "/member/official/form",
        method: "GET",
        params
    })

// 官方达人-达人信息
export const getOfficalInfo = (params: any) =>
    request({
        url: "/member/official/info",
        method: "GET",
        params
    })

// 官方达人-修改达人信息
export const setMemberMsg = (data: any) =>
    request({
        url: "/member/official/infoSet",
        method: "POST",
        data
    })

// 官方达人-用户全部的会话列表
export const getChatsList = (params?: any) =>
    request({
        url: "/member/official/chatsList",
        method: "GET",
        params
    })

// 官方达人-用户全部的会话列表(未读数量)
export const getChatsNum = (params?: any) =>
    request({
        url: "/member/official/chatsListForm",
        method: "GET",
        params
    })// 官方达人-单个达人用户全部的会话列表(未读数量)
export const getChatsUnreadNum = (params?: any) =>
    request({
        url: "/basis/customerIm/chatLogsTotal",
        method: "GET",
        params
    })


// 官方达人-达人聊天会话列表
export const getchatList = (params: any) =>
    request({
        url: "/basis/CustomerIm/chats",
        method: "GET",
        params
    })

// 官方达人-达人聊天会话信息
export const getChatInfo = (params: any) =>
    request({
        url: "/basis/CustomerIm/chat",
        method: "GET",
        params
    })

// 官方达人-达人聊天记录
export const getChatLogs = (params: any) =>
    request({
        url: "/basis/customerIm/chatLogs",
        method: "GET",
        params
    })

// 官方达人-移除聊天记录
export const delChatLogs = (data: any) =>
    request({
        url: "/basis/customerIm/chatLogsRemove",
        method: "POST",
        data
    })

//  官方达人-聊天常用语
export const getChatWords = (params: any) =>
    request({
        url: "/basis/customerIm/chatWords",
        method: "GET",
        params
    })

// 官方达人-聊天语编辑/添加
export const setChatWords = (data: any) =>
    request({
        url: "/basis/customerIm/chatWordSet",
        method: "POST",
        data
    })

// 官方达人-聊天语置顶
export const makeWordsTop = (data: any) =>
    request({
        url: "/basis/customerIm/chatWordTop",
        method: "POST",
        data
    })

// 官方达人-发送聊天消息
export const sendMsg = (data: any) =>
    request({
        url: "/basis/customerIm/message",
        method: "POST",
        data
    })

// 官方达人-会话已读
export const readChat = (params: any) =>
    request({
        url: "/basis/customerIm/chatRead",
        method: "GET",
        params
    })

// 官方达人-所有会话已读
export const readAllChat = (params: any) =>
    request({
        url: "/basis/customerIm/chatReadAll",
        method: "GET",
        params
    })

// 官方达人-未读聊天记录数量
export const getUnreadNum = (params: any) =>
    request({
        url: "/member/official/chatLogsTotal",
        method: "GET",
        params
    })

// 官方达人-会话置顶
export const setChatTop = (data: any) =>
    request({
        url: "/basis/customerIm/chatTop",
        method: "POST",
        data
    })

// 官方达人-拉黑用户
export const banMember = (data: any) =>
    request({
        url: "/basis/customerIm/ban",
        method: "POST",
        data
    })

// 服务认证-选项数据
export const getSkillForm = (params?: any) =>
    request({
        url: "/member/official/skillForm",
        method: "GET",
        params
    })

// 服务认证-添加服务
export const addSkill = (data: any) =>
    request({
        url: "/member/official/skillAdd",
        method: "POST",
        data
    })

// 服务认证-修改服务信息
export const setServeInfo = (data: any) =>
    request({
        url: "/member/official/skillInfoSet",
        method: "POST",
        data
    })

// 服务认证-服务信息详情
export const getServeInfo = (params?: any) =>
    request({
        url: "/member/official/skillInfo",
        method: "GET",
        params
    })

// 服务认证-开启/关闭接单
export const setOrderDealStatus = (data: any) =>
    request({
        url: "/member/official/skillOrderStatusSet",
        method: "POST",
        data
    })

//  接单列表
export const getOfficialOrders = (params?: any) =>
    request({
        url: "/admin.php/member/official/order",
        method: "GET",
        params
    })

// 接单列表-接单数量
export const getOfficialNum = (params?: any) =>
    request({
        url: "/member/official/orderNum",
        method: "GET",
        params
    })

// 用户注销-注销列表
export const getDestroyList = (params?: any) =>
    request({
        url: "/member/logout/list",
        method: "GET",
        params
    })

// 用户注销-注销详情
export const getDestroyDetail = (params: any) =>
    request({
        url: "/member/logout/info",
        method: "GET",
        params
    })

// 用户注销-撤销申请
export const revokeDestroy = (data: any) =>
    request({
        url: "/member/logout/revoke",
        method: "POST",
        data
    })

// 用户标签-选项数据
export const getTags = (params?: any) =>
    request({
        url: "/member/tag/form",
        method: "GET",
        params
    })

// 用户标签-添加用户标签
export const addTag = (data: any) =>
    request({
        url: "/member/tag/add",
        method: "POST",
        data
    })

// 用户标签-移除用户标签
export const delTag = (data: any) =>
    request({
        url: "/member/tag/del",
        method: "POST",
        data
    })
// 作品库认证-选项数据
export const getWorksOptions = (params?: any) =>
    request({
        url: "/member/skillWorks/form",
        method: "GET",
        params
    })
// 作品库认证-作品列表
export const getWorksList = (params?: any) =>
    request({
        url: "/member/skillWorks/list",
        method: "GET",
        params
    })
// 作品库认证-作品信息
export const getWorksInfo = (params: any) =>
    request({
        url: "/member/skillWorks/info",
        method: "GET",
        params
    })
// 作品库认证-审核作品
export const checkWork = (data: any) =>
    request({
        url: "/member/skillWorks/check",
        method: "POST",
        data
    })
// 企业认证-认证列表
export const getCompanyAuthList = (params?: any) =>
    request({
        url: "/member/company/list",
        method: "GET",
        params
    })
// 企业认证-认证详情
export const getCompanyAuthInfo = (params: any) =>
    request({
        url: "/member/company/info",
        method: "GET",
        params
    })
// 企业认证-认证审核
export const checkCompanyAuth = (data: any) =>
    request({
        url: "/member/company/check",
        method: "POST",
        data
    })
// 企业认证-批量审核
export const checkBatchCompanyAuth = (data: any) =>
    request({
        url: "/member/company/batchCheck",
        method: "POST",
        data
    })

// 支付宝认证-列表
export const getAliPayList = (params?: any) =>
    request({
        url: "/member/alipayAuth",
        method: "GET",
        params
    })

//接单列表-订单详情
export const orderInfo = (params: any) =>
    request({
        url: '/member/official/orderInfo',
        method: 'GET',
        params
    })
//接单列表-拒绝理由
export const getReasonList = (params: any) =>
    request({
        url: '/member/official/chooseReason',
        method: 'GET',
        params
    })
//接单列表-拒绝接单
export const orderRefuse = (data: any) =>
    request({
        url: '/member/official/orderRefuse',
        method: 'POST',
        data
    })
//接单列表-立即接单
export const orderReceipt = (data: any) =>
    request({
        url: '/member/official/orderReceipt',
        method: 'POST',
        data
    })
//接单列表-申请服务完成
export const applyFinsh = (data: any) =>
    request({
        url: '/member/official/orderSubmit',
        method: 'POST',
        data
    })
//接单列表-退款详情
export const getRefundDetail = (params: any) =>
    request({
        url: '/order/refund/info',
        method: 'POST',
        params
    })
//接单系统-退款审核
export const orderRefundCheck = (data: any) =>
    request({
        url: '/member/official/orderRefundCheck',
        method: 'POST',
        data
    })
//接单系统-获取订单价格
export const getOrderPrice = (params: any) =>
    request({
        url: '/member/official/getOrderPrice',
        method: 'GET',
        params
    })
//接单系统-订单改价
export const orderPriceChange = (data: any) =>
    request({
        url: '/member/official/orderPriceChange',
        method: 'POST',
        data
    })
// 接单列表-多订单信息
export const getOrdersMsg = (params: any) =>
    request({
        url: '/member/official/multiOrder',
        method: 'GET',
        params
    })
// 接单系统-主体数据
export const getOfficalData = (params?: any) =>
    request({
        url: '/member/official/data',
        method: 'GET',
        params
    })

// 用户信息改绑支付宝
export const orderAlipayId = (data: any) =>
    request({
        url: '/member/rebindAlipay',
        method: 'POST',
        data
    })

//用户信息-用户列表-使用数据
export const getUserUseInfo = (params?: any) =>
    request({
        url: '/member/using',
        method: 'GET',
        params
    })
//雇员管理-经理列表
export const getManagerList = (params: any) =>
    request({
        url: '/staff/manager',
        method: 'GET',
        params
    })
//雇员管理-添加雇员组
export const addGroup = (data: any) =>
    request({
        url: '/staff/add',
        method: 'POST',
        data
    })
//雇员管理-添加部门-选项数据
export const addForm = () =>
    request({
        url: '/staff/form',
        method: 'GET'
    })
//雇员管理-雇员搜索
export const staffSearch = (params: any) =>
    request({
        url: '/staff/search',
        method: 'GET',
        params
    })
//雇员管理-组长组员列表
export const groupMemberList = (params: any) =>
    request({
        url: '/staff/team',
        method: 'GET',
        params
    })

//雇员管理-删除雇员
export const deleteStaff = (data: any) =>
    request({
        url: '/staff/del',
        method: 'POST',
        data
    })
//业绩统计-总计
export const achievementTotal = (params: any) =>
    request({
        url: '/staff/performance/total',
        method: 'GET',
        params
    })
//业绩统计-经理总计
export const managerAchievement = (params: any) =>
    request({
        url: '/staff/performance/managerData',
        method: 'GET',
        params
    })
//业绩统计-小组总计
export const groupAchievement = (params: any) =>
    request({
        url: '/staff/performance/teamData',
        method: 'GET',
        params
    })
//业绩查询-业绩列表
export const achievementList = (params: any) =>
    request({
        url: '/staff/performance/list',
        method: 'GET',
        params
    })
//业绩查询-增加业绩
export const addAchievement = (data: any) =>
    request({
        url: '/staff/performance/add',
        method: 'POST',
        data
    })
//业绩查询-修改所属雇员
export const changeStaff = (data: any) =>
    request({
        url: '/staff/performance/set',
        method: 'POST',
        data
    })
//客户资源-列表数据
export const customerList = (params: any) =>
    request({
        url: '/staff/customer/customerList',
        method: 'GET',
        params
    })
//客户资源-列表选项
export const customerForm = (params: any) =>
    request({
        url: '/staff/customer/form',
        method: 'GET',
        params
    })
//客户资源-添加新客户
export const addCustomer = (data: any) =>
    request({
        url: '/staff/customer/addCustomer',
        method: 'POST',
        data
    })
//客户资源-分配雇员列表
export const staffList = (params: any) =>
    request({
        url: '/staff/customer/staffList',
        method: 'GET',
        params
    })
//客户资源-分配雇员
export const dispatchStaff = (data: any) =>
    request({
        url: '/staff/customer/allot',
        method: 'POST',
        data
    })
//客户资源-详情
export const customerDetails = (params: any) =>
    request({
        url: '/staff/customer/customerInfo',
        method: 'GET',
        params
    })
//客户资源-修改生命周期
export const setCustomerState = (data: any) =>
    request({
        url: '/staff/customer/setState',
        method: 'POST',
        data
    })
//客户资源-添加跟进记录
export const addFollowLog = (data: any) =>
    request({
        url: '/staff/customer/addFollow',
        method: 'POST',
        data
    })
//客户资源-删除跟进记录
export const deleteFollowLog = (data: any) =>
    request({
        url: '/staff/customer/delFollow',
        method: 'POST',
        data
    })
//客户资源-编辑基本信息
export const modifyInfo = (data: any) =>
    request({
        url: '/staff/customer/setCustomer',
        method: 'POST',
        data
    })

// 资金充值 - 选项数据
export const getRechargeForm = (params: any) =>
    request({
        url: '/trade/amount/form',
        method: 'GET',
        params
    })

// 资金充值 - 搜索账号
export const getTradeAccountInfo = (params: any) =>
    request({
        url: '/trade/amount/accountInfo',
        method: 'GET',
        params
    })

// 资金充值 - 自动获取赠送金额
export const getMoneyOfGift = (params: any) =>
    request({
        url: '/trade/amount/gift',
        method: 'GET',
        params
    })

// 资金充值
export const rechargeTradeMoney = (data: any) =>
    request({
        url: '/trade/amount/recharge',
        method: 'POST',
        data
    })

// 计划管理-选项数据
export const getPlanOfOptions = (params: any) =>
    request({
        url: '/seller/task/form',
        method: 'GET',
        params
    })

// 计划列表
export const getPlanOfList = (params: any) =>
    request({
        url: '/seller/task/list',
        method: 'GET',
        params
    })

// 启动计划
export const runPlan = (data: any, batch: Boolean = false) =>
    request({
        url: '/seller/task/start',
        method: 'POST',
        data,
        showToast: !batch
    })

// 暂停计划
export const stopPlan = (data: any) =>
    request({
        url: '/seller/task/stop',
        method: 'POST',
        data
    })

// 重启计划
export const restartPlan = (data: any) =>
    request({
        url: '/seller/task/restart',
        method: 'POST',
        data
    })

// 删除计划
export const deletePlan = (data: any) =>
    request({
        url: '/seller/task/delete',
        method: 'POST',
        data
    })

// 核算计划
export const checkPlan = (data: any) =>
    request({
        url: '/seller/task/settlement',
        method: 'POST',
        data
    })

// 参与列表 - 选项数据
export const getAddListForm = (params: any) =>
    request({
        url: '/member/task/listForm',
        method: 'GET',
        params
    })

// 计划列表
export const getPlanTaskList = (params: any) =>
    request({
        url: '/member/task/list',
        method: 'GET',
        params
    })

//邀请明细
export const getInviteAward = (params: any) =>
    request({
        url: '/member/award/list',
        method: 'GET',
        params
    })

//奖励统计
export const getAwardTotal = (params: any) =>
    request({
        url: '/member/award/total',
        method: 'GET',
        params
    })

//邀请统计
export const getInviteTotal = (params: any) =>
    request({
        url: '/member/invite/total',
        method: 'GET',
        params
    })

//邀请列表
export const getInviteList = (params: any) =>
    request({
        url: '/member/invite/list',
        method: 'GET',
        params
    })

// 计划信息
export const getPlanInfomation = (params: any) =>
    request({
        url: '/seller/task/info',
        method: 'GET',
        params
    })

// 获取商品信息
export const getTaskGoodsInfo = (params: any) =>
    request({
        url: '/seller/task/getGoodsInfo',
        method: 'GET',
        params
    })

// 任务问卷数量分配数据
export const getDistributeData = (params: any) =>
    request({
        url: '/seller/task/getDistributeData',
        method: 'GET',
        params
    })

// 计算任务费用
export const calcTaskFee = (data: any) =>
    request({
        url: '/seller/task/computeFee',
        method: 'POST',
        data
    })

// 修改计划任务
export const modifyTask = (data: any) =>
    request({
        url: '/seller/task/set',
        method: 'POST',
        data
    })


// 发布任务
export const publishTask = (data: any) =>
    request({
        url: '/seller/task/add',
        method: 'POST',
        data
    })

// 任务领取列表
export const getReceiveList = (params: any) =>
    request({
        url: '/seller/task/receive',
        method: 'GET',
        params
    })

// 参与列表-选项数据
export const getJoinListForm = (params: any) =>
    request({
        url: '/member/task/listForm',
        method: 'GET',
        params
    })

// 计划数据趋势
export const getTaskTrend = (params: any) =>
    request({
        url: '/seller/task/trends',
        method: 'GET',
        params
    })

// 参与列表
export const getJoinList = (params: any) =>
    request({
        url: '/member/task/list',
        method: 'GET',
        params
    })

// 任务详情 - 选项数据
export const getTaskForm = (params: any) =>
    request({
        url: '/seller/task/infoForm',
        method: 'GET',
        params
    })

// 提现审核
export const checkWithdraw = (data: any, batch: Boolean = false) =>
    request({
        url: '/member/withdraw/check',
        method: 'POST',
        data,
        showToast: !batch
    })

//获取一键登录
export const oneClick = (params: any) =>
    request({
        url: '/basis/authUser/loginLink',
        method: 'GET',
        params
    })

// openid登录
export const signOpeid = (data: any) =>
    request({
        url: '/uniLogin',
        method: 'POST',
        data
    })

// openid登录
export const gitInterface = (params: any) =>
    request({
        url: '/basis/apiAbnormal/list',
        method: 'GET',
        params
    })

//接口异常-选项数据
export const gitException = (data: any) =>
    request({
        url: '/basis/apiAbnormal/form',
        method: 'GET',
        data
    })

// 轮播图 - 选项数据
export const getSwiperOptions = (params: any) =>
    request({
        url: '/basis/siteSource/form',
        method: 'GET',
        params
    })

// 轮播图列表
export const getSwipers = (params: any) =>
    request({
        url: '/basis/siteSource/list',
        method: 'GET',
        params
    })

// 添加轮播图
export const addSwiper = (data: any) =>
    request({
        url: '/basis/siteSource/add',
        method: 'POST',
        data
    })

// 编辑轮播图
export const editSwiper = (data: any) =>
    request({
        url: '/basis/siteSource/set',
        method: 'POST',
        data
    })

// 轮播图详情
export const getSwiperInfo = (params: any) =>
    request({
        url: '/basis/siteSource/info',
        method: 'GET',
        params
    })

// 删除轮播图
export const delSwiper = (data: any) =>
    request({
        url: '/basis/siteSource/del',
        method: 'POST',
        data
    })

// 修改状态
export const changeSwiperStatus = (data: any) =>
    request({
        url: '/basis/siteSource/setStatus',
        method: 'POST',
        data
    })

//用户列表-获取一键登录
export const openidLink = (params: any) =>
    request({
        url: '/member/getLoginLink',
        params,
        method: 'GET'
    })
//用户列表-登录二维码
export const loginQrcode = (params: any) =>
    request({
        url: '/member/qrCode',
        params,
        method: 'GET'
    })
//雇员管理-排序
export const sellSort = (data: any) =>
    request({
        url: '/staff/sort',
        data,
        method: 'POST'
    })

//管理员列表 - 选项数据
export const gitAuthUser = (params: any) =>
    request({
        url: '/basis/authUser/form',
        params,
        method: 'GET'
    })
//邀请奖励-数据趋势-累计数据
export const invitedTrendTotal = (params: any) =>
    request({
        url: '/data/invite/main',
        params,
        method: 'GET'
    })
//邀请奖励-数据趋势-折线图
export const invitedTrendCharts = (params: any) =>
    request({
        url: '/data/invite/trend',
        params,
        method: 'GET'
    })
//邀请奖励-数据趋势-排行榜
export const invitedRanking = (params: any) =>
    request({
        url: '/member/invite/rank',
        params,
        method: 'GET'
    })
//雇员管理-业绩查询统计
export const achievementSearchTotal = (params: any) =>
    request({
        url: '/staff/performance/searchTotal',
        params,
        method: 'GET'
    })
//商家统计-商家列表
export const businessmanList = (params: any) =>
    request({
        url: '/staff/seller',
        params,
        method: 'GET'
    })
//商家统计-商家总数
export const businessmanTotal = (params: any) =>
    request({
        url: '/staff/sellerTotal',
        params,
        method: 'GET'
    })
//商家统计-商家总数
export const staffTree = (params: any) =>
    request({
        params,
        url: '/staff/staff',
        method: 'GET'
    })

// 计划 - 作弊监测
export const watchList = (params: any) => {
    let url = params.url;

    delete params.url;
    return request({
        url,
        method: 'GET',
        params,
    })
}

// 任务 - 获取分享链接
export const getShareLink = (params: any) =>
    request({
        params,
        url: '/seller/task/getShareLink',
        method: 'GET'
    })

// 作弊检测 - 冻结账号
export const frozenAccount = (data: any) =>
    request({
        data,
        url: '/member/task/addFrozen',
        method: 'POST'
    })

// 作弊检测 - 取消冻结
export const cancleFrozenUser = (data: any) =>
    request({
        data,
        url: '/member/task/cancelFrozen',
        method: 'POST'
    })

// 大神认证-游戏等级/职务/段位/标签
export const getTalentOfOptions = (params:any) =>
    request({
        params,
        url: '/member/game/authForm',
        method: 'GET'
    })

// 大神认证-添加/更新认证
export const setToTalentAuth = (data: any) =>
    request({
        data,
        url: '/member/game/auth',
        method: 'POST'
    })

// 大神认证-认证信息
export const getTalentInfo = (params: any) =>
    request({
        params,
        url: '/member/game/info',
        method: 'GET'
    })

// 大神列表-选项数据
export const getTalentListOptions = () =>
    request({
        url: '/member/game/form',
        method: 'GET'
    })

// 游戏配置 - 信息
export const getGameInfo = (params:any) =>
    request({
        params,
        url: '/market/game/info',
        method: 'GET'
    })

// 游戏配置-修改配置
export const changeGameInfo = (data: any) =>
    request({
        data,
        url: '/market/game/set',
        method: 'POST'
    })

// 游戏配置 - 选项数据
export const getGameOptions = () =>
    request({
        url: '/market/game/addForm',
        method: 'GET'
    })
//订单列表-选项数据
export const getOrderOptions = (params: any) =>
    request({
        url: '/order/form',
        method: 'GET',
        params
    })
//俱乐部-物品-表单数据
export const getItemOptions = (params: any) =>
    request({
        url: '/club/item/form_data',
        method: 'GET',
        params
    })
//俱乐部-物品-添加
export const getItemModify = (data: any) =>
    request({
        url: '/club/item/modify',
        method: 'POST',
        data
    })
//俱乐部-物品-列表
export const getItemList = (data: any) =>
    request({
        url: '/club/item/list',
        method: 'POST',
        data
    })
//俱乐部-物品-设置版本可用
export const setItemSel = (data: any) =>
    request({
        url: '/club/item/sel_edit',
        method: 'POST',
        data
    })
//俱乐部-物品-列表
export const getItemTemplateList = (data: any) =>
    request({
        url: '/club/item/tp_list',
        method: 'POST',
        data
    })
//创建订单-获取大神令
export const getCodeInfo = (params: any) =>
    request({
        params,
        url: '/order/codeInfo',
        method: 'GET'
    })
//创建订单-搜索大神信息
export const getGodInfo = (params: any) =>
    request({
        params,
        url: '/order/search',
        method: 'GET'
    })
//创建订单-游戏段位
export const getGameLever = () =>
    request({
        url: '/order/project',
        method: 'GET'
    })
//创建订单-计算费用
export const calOrderPrice = (params: any) =>
    request({
        params,
        method: "GET",
        url: '/order/calculatePrice'
    })
//创建订单-创建
export const addOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/add'
    })

// 大神列表 - 选项数据
export const getTalentOptions = () =>
    request({
        method: 'GET',
        url: '/member/game/form'
    })

// 大神列表
export const getTalentList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/game/list'
    })

// 大神列表 - 关闭订单状态
export const closeOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/game/orderClose'
    })

// 大神列表 - 开启订单状态
export const startOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/game/orderOpen'
    })
//订单列表-表格数据
export const orderList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/list'
    })
//订单-编辑订单
export const orderSet = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/set'
    })
//订单-订单详情
export const orderDetails = (params: any) =>
    request({
        params,
        method: 'POST',
        url: '/order/info'
    })
//订单-设定字段
export const setField = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/setField'
})
//订单-启动
export const openOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/start'
    })
//订单-订单数量
export const orderNum = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/orderNum'
    })
//订单-删除订单
export const deleteOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/delete'
    })
//订单-删除订单
export const cancelOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/cancel'
    })
//订单-完成订单
export const completeOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/finish'
    })
//订单-核算订单
export const settleOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/settle'
    })
//订单-订单退款
export const orderRefund = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/refund'
    })
//订单-计算退款费用
export const calRefund = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/calculateRefund'
    })
//编辑订单-获取详情
export const getEditOrderInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/orderInfo'
    })

// 修改服务审核 - 列表选项数据
export const getServiceOptions = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/game/operateForm'
    })

// 修改服务审核 - 列表
export const getServiceList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/game/operateList'
    })

// 修改服务审核 - 列表 / 用户游戏操作列表 - 审核
export const goCheckService = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/game/operateCheck'
    })

// 大神扣款 - 选项数据(列表)
export const getDeductOptions = () =>
    request({
        method: 'GET',
        url: '/member/deduct/form'
    })

// 大神扣款-列表
export const getTalentDeduct = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/deduct/list'
    })

// 大神扣款 - 扣款选项数据
export const getTalentDeductForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/deduct/deductForm'
    })

// 大神扣款 - 查询用户信息
export const queryInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/deduct/accountInfo'
    })

// 大神扣款-搜索订单
export const queryOrder = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/deduct/searchOrder'
    })

// 大神扣款 - 扣款
export const deductTalent = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/deduct/deduct'
    })

// 大神状态列表
export const getDeductAll = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/deduct/total'
    })

// 大神状态 - 选项数据
export const getTalentStatus = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/game/statusForm'
    })

// 大神状态列表
export const getTalentStatusList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/game/statusList'
    })
//线下派单-创建订单
export const addOfflineOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/add'
    })
//线下派单-选项数据
export const offlineOrderForm = () =>
    request({
        method: 'GET',
        url: '/order/offline/addForm'
    })
//线下派单-列表选项
export const offlineOptions = () =>
    request({
        method: 'GET',
        url: '/order/offline/form'
    })
//线下派单-订单列表
export const offlineOrderList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/list'
    })
//线下派单-订单数量
export const offlineOrderNum = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/orderNum'
    })
//线下派单-新增-等级
export const offlineOrderLevel = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/level'
    })
//线下派单-新增-段位
export const offlineOrderProject = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/project'
    })
//线下-计算费用
export const offLineCalOrderPrice = (params: any) =>
    request({
        params,
        method: "GET",
        url: '/order/offline/calculatePrice'
    })
//线下-编辑订单详情
export const getOfflineEditOrderInfo = (params: any) =>
    request({
        params,
        url: '/order/offline/orderInfo',
        method: 'GET'
    })
//线下-编辑订单-提交
export const offlineOrderSet = (data: any) =>
    request({
        data,
        url: '/order/offline/set',
        method: 'POST'
    })
//线下-订单详情
export const offlineOrderDetails = (params: any) =>
    request({
        params,
        url: '/order/offline/info',
        method: 'GET'
    })
//线下-发起支付
export const offlinePay = (data: any) =>
    request({
        data,
        url: '/order/offline/pay',
        method: 'POST'
    })
//线下-发起支付-查看信息
export const offlinePayInfo = (params: any) =>
    request({
        params,
        url: '/order/offline/payInfo',
        method: 'get'
    })
//线下-启动
export const openOrderOffline = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/start'
    })
//线下-删除订单
export const deleteOrderOffline = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/delete'
    })
//线下-取消订单
export const cancelOrderOffline = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/cancel'
    })
//线下-完成订单
export const completeOrderOffline = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/finish'
    })
//线下-订单退款
export const orderRefundOffline = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/offline/refund'
    })
//线下-计算退款费用
export const calRefundOffline = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/calculateRefund'
    })
//线下-查询大神
export const searchGod = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/search'
    })
//打赏列表-打赏列表
export const rewardList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/reward/list'
    })
//打赏列表-选项数据
export const rewardForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/reward/form'
    })
//打赏列表-打赏统计
export const rewardTotal = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/reward/total'
    })
//评论列表-选项数据
export const commentList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/comment/list'
    })
//评论列表-选项数据
export const commentForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/comment/form'
    })
//充值-选项数据
export const marketRechargeForm = () =>
    request({
        method: 'GET',
        url: '/market/recharge/form'
    })
//充值-总计
export const marketRechargeTotal = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/recharge/total'
    })
//充值-列表
export const marketRechargeList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/recharge/list'
    })
//业绩查询-选项
export const achievementForm = () =>
    request({
        method: 'GET',
        url: '/staff/performance/form'
    })
//业绩趋势-统计
export const achievementTrendTotal = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/staff/main'
    })
//业绩趋势-统计图表
export const achievementTrendDetails = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/staff/trend'
    })
//充值趋势-统计
export const rechargeTrendTotal = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/trade/rechargeMain'
    })
//充值趋势-统计图标
export const rechargeTrendDetails = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/trade/rechargeTrend'
    })
// 评论趋势-统计
export const dataOrderCommentMain = () =>
    request({
        method: 'GET',
        url: '/data/order/commentMain'
    })
// 评论趋势-统计数据
export const dataOrderCommentTrend = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/order/commentTrend'
    })
// 打赏趋势-统计
export const getRewardStatistics = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/order/rewardMain'
    })
// 打赏趋势-统计图表
export const getRewardTrend = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/data/order/rewardTrend'
    })
//接单看板-统计
export const receiptNum = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/receiptNum'
    })
//接单看板-列表
export const receiptList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/receiptList'
    })
// 老板余额
export const memberAmount = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/amount'
    })
//全局搜索资金/流水编号
export const searchNo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/searchNo'
    })
//提现管理/搜索资金信息
export const gitFundNo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/withdraw/searchNo'
    })
//充值列表-搜索资金/流水编号
export const rechargeSearchNo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/recharge/searchNo'
    })
//捏脸帖子-帖子列表
export const faceList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/square/list'
    })
//捏脸帖子-列表选项
export const faceForm = () =>
    request({
        method: 'GET',
        url: '/market/square/form'
    })
//捏脸帖子-详情
export const faceInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/square/info'
    })
//捏脸帖子-新增
export const addFace = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/square/add'
    })
//捏脸帖子-修改帖子状态
export const changeFaceStatus = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/square/setStatus'
    })
//捏脸帖子-删除
export const delFace = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/square/del'
    })
//捏脸帖子-编辑
export const modifyFace = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/square/set'
    })
//捏脸帖子- 分类列表
export const faceCate = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/squareCategory/list'
    })
//捏脸帖子- 添加分类
export const addFaceCate = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/squareCategory/add'
    })
//捏脸帖子- 分类详情
export const faceCateInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/squareCategory/info'
    })
//捏脸帖子- 编辑分类
export const modifyFaceCate = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/squareCategory/set'
    })
//捏脸帖子- 删除分类
export const delfaceCate = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/squareCategory/del'
    })
//存单老板-选项
export const saveBossForm = () =>
    request({
        method: 'GET',
        url: '/member/boss/form'
    })
//创建订单-选项
export const orderAddForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/addForm'
    })
//临时标签添加
export const orderAddFormTag = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/addFormTag'
    })
//快捷订单操作
export const orderQuickModify = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickModify'
    })
export const orderQuickPayInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickPayInfo'
    })
export const orderQuickInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickInfo'
    })
//快捷订单--列表
export const orderQuickList = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickList'
    })
//快捷订单--老板编号的金额
export const orderQuickListBoss = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickListBoss'
    })
//快捷订单--日志
export const orderQuickLog = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickLog'
    })
//快捷订单--统计
export const orderQuickTotal= (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickTotal'
    })
//快捷订单--统计--环比
export const orderQuickTotalHB= (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderQuickTotalHB'
    })
//用户最后接单统计
export const userLastOrderTotal= (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderLastTotal'
    })
//最近账单
export const userAlipayAccountLog= (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/orderAlipayAccountLog'
    })
//存单老板-列表
export const saveBossList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/boss/list'
    })
//存单老板-新建老板
export const addSaveBoss = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/add'
    })
//存单老板-新建老板
export const editSaveBoss = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/set'
    })
//存单老板-办理存单选项
export const saveBossRechargeForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/boss/rechargeForm'
    })
//存单老板-办理存单
export const addSaveBossRecharge = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/recharge'
    })
//存单老板-办理存单
export const addSaveBossOrder = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/recharge'
    })
//存单老板-点单-选项
export const saveOrderFrom = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/boss/orderAddForm'
    })
//存单老板-点单-创建
export const saveOrderAdd = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/orderAdd'
    })
//存单老板-存单记录
export const saveBossLog = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/boss/log'
    })
//优惠券列表-选项数据
export const getCouponForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/form'
    })
//优惠券列表
export const getCouponList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/list'
    })
//添加优惠券
export const saveCouponAdd = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/coupon/add'
    })
//添加/编辑优惠券-选项数据
export const getAddForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/addForm'
    })
//编辑优惠券
export const updateCouponSet = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/coupon/set'
    })
//优惠券详情
export const getCouponInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/info'
    })
//优惠券设为无效
export const invalidCoupon = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/coupon/invalid'
    })
//删除优惠券
export const delCoupon = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/coupon/del'
    })
//生成兑换码
export const couponCode = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/code/create'
    })
//生成兑换码-选项数据
export const couponCodeForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/code/createForm'
    })
//兑换码列表
export const couponCodeList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/code/list'
    })
//添加库存
export const addCouponStock = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/market/coupon/addStock'
    })
//使用明细
export const couponUseLog = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/useLog'
    })
//使用明细-选项数据
export const couponUseForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/market/coupon/useForm'
    })
//可用/不可用优惠券列表
export const orderCoupon = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/coupon'
    })
//照片墙审核-选项
export const worksForm = () =>
    request({
        method: 'GET',
        url: '/member/works/form'
    })
//照片墙审核-列表
export const worksList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/works/list'
    })
//照片墙审核-详情
export const worksInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/works/info'
    })
//照片墙审核-审核
export const worksCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/works/check'
    })
//搜索雇员
export const searchCustomer = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/basis/sysCustomer/search'
    })
//修改客服状态
export const setCustomerStatus = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/basis/sysCustomer/setStatus'
    })
//认证技能服务 - 选项数据
export const authListForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authListForm'
    })
//认证技能服务
export const getAuthList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authList'
    })
//证技能服务 - 认证审核
export const setAuthCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/worker/authCheck'
    })
//认证技能服务 - 认证信息
export const getAuthInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authInfo'
    })
// 上传音频
export const setAudio = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/upload/audio'
    })
//认证技能服务 - 选项数据
export const authSetListForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authSetListForm'
    })
//修改认证技能服务 - 列表数据
export const getAuthSetList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authSetList'
    })
//修改认证技能服务 - 认证信息
export const authSetInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/worker/authSetInfo'
    })
//修改认证技能服务 - 认证审核
export const authSetCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/worker/authSetCheck'
    })
//会员管理照片墙 - 编辑图片
export const setPicWall = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/setWorks'
    })
//会员管理 - 大神 - 开启接单
export const godOrderOpen = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/orderOpen'
    })
//会员管理 - 大神 - 关闭接单
export const godOrderClose = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/orderClose'
    })
//会员管理 - 大神 - 认证详情
export const godAuthInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/authInfo'
    })
//会员管理 - 大神 - 认证编辑
export const godAuthInfoSet = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/authSetInfo'
    })
//房间管理 -房间号-列表
export const roomList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/number/list'
    })
//房间管理 - 添加房间号
export const addRomm = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/number/add'
    })
//房间管理 - 删除房间号
export const delRomm = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/number/del'
    })
//添加房间-选项数据
export const addRoomForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/room/addForm'
    })
//添加房间
export const addNewestRoom = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/room/add'
    })
//约玩-列表
export const playOrderList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/play/list'
    })
//约玩-选项数据
export const playOrderForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/play/form'
    })
//约玩-订单数量
export const playOrderNum = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/play/orderNum'
    })
//约玩-订单详情
export const playOrderDetails = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/play/info'
    })
//约玩-试音列表
export const playOrderVoiceList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/play/sendList'
    })
//约玩-取消订单
export const playOrderCancel = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/play/cancel'
    })
//约玩-组队
export const playOrderStart = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/play/start'
    })
//约玩-计算退款费用
export const playOrderCalRefund = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/order/offline/calculateRefund'
    })
//约玩-退款
export const playOrderRefund = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/play/refund'
    })
//约玩-确认完成
export const playOrderFinsh = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/play/finish'
    })
//名片认证-选项数据
export const cardAuthForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/cardAuth/form'
    })
// 名片认证-列表
export const cardAuthList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/cardAuth/list'
    })
// 名片认证-详情
export const cardAuthInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/cardAuth/info'
    })
// 认证名片-审核
export const cardAuthCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/cardAuth/check'
    })
// 语音房-房间列表
export const voiceRoomList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/room/list'
    })
// 语音房-列表选项数据
export const formList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/room/form'
    })
// 语音房-编辑房间
export const editRoom = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/room/set'
    })
// 语音房-房间状态
export const roomSetStatus = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/room/setStatus'
    })
// 语音房-删除房间
export const roomDel = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/room/del'
    })
// 语音房-房间置顶
export const rooTop = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/room/top'
    })
// 语音房-房间信息
export const roomInformation = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/room/info'
    })
// 礼物分类-列表
export const giftCategoryList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/giftCategory/list'
    })
// 礼物分类 -添加
export const addToGift = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/giftCategory/add'
    })
//礼物分类-删除分类
export const deleteNickname = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/giftCategory/del'
    })
//礼物分类-新礼物添加
export const addGift = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/gift/add'
    })
// 礼物-选项数据(列表)
export const giftForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/gift/form'
    })
// 礼物-列表
export const giftList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/gift/list'
    })
// 礼物-详情
export const giftDetails = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/gift/info'
    })
//礼物-删除
export const delGift = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/gift/del'
    })
//礼物-编辑
export const editGift = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/gift/set'
    })
// 会员列表-修改number
export const setNumber = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/changeNumber'
    })
// 礼物-修改状态
export const stateGift = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/gift/setStatus'
    })
// 礼物-赠送记录(选项数据)
export const giveForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/gift/rewardForm'
    })
//礼物-赠送记录(列表)
export const giftRewardList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/gift/rewardList'
    })
//派单记录-选项数据
export const demandForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/demand/form'
    })
//派单记录-列表
export const demandList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/room/demand/list'
    })
//全局服务配置-获取配置
export const getServiceSet = ()=>
    request({
        method:'GET',
        url:'/market/game/config'
    })
//全局服务配置-获取配置
export const editServiceSet = (data:any)=>
    request({
        data,
        method:'POST',
        url:'/market/game/setConfig'
    })
//服务管理-列表选项
export const serviceListForm = (params:any)=>
    request({
        params,
        method:'GET',
        url:'/market/game/form'
    })
//实名认证(列表)
export const idCardAuthList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/idCardAuthList'
    })
//实名认证(选项数据)
export const idCardAuthForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/idCardAuthForm'
    })
//实名认证(信息审核)
export const idCardAuthCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/idCardAuthCheck'
    })
//实名认证信息
export const idCardAuthFormInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/member/idCardAuthInfo'
    })

//服务管理-列表
export const serviceList = (params:any)=>
    request({
        params,
        method:'GET',
        url:'/market/game/list'
    })
//服务管理-修改禁用状态
export const serviceSetStatus = (data:any)=>
    request({
        data,
        method:'POST',
        url:'/market/game/setStatus'
    })
//服务管理-修改认证状态
export const serviceSetAuthStatus = (data:any)=>
    request({
        data,
        method:'POST',
        url:'/market/game/setAuthStatus'
    })
//服务管理-新增
export const addService = (data:any)=>
    request({
        data,
        method:'POST',
        url:'/market/game/add'
    })
//服务管理-打赏配置
export const rewardConfig = ()=>
    request({
        method:'GET',
        url:'/order/reward/config'
    })
//服务管理-修改打赏配置
export const setRewardConfig = (data:any)=>
    request({
        data,
        method:'POST',
        url:'/order/reward/setConfig'
    })
//礼物打赏配置-选项数据
export const gitConfig = (data: any) =>
    request({
        data,
        method: 'GET',
        url: '/room/gift/config'
    })
//修改打赏配置
export const giftSetConfig = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/room/gift/setConfig'
    })
//插件列表
export const pluginList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/plugin/plugin/list'
    })
//插件详情
export const pluginInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/plugin/plugin/config'
    })
//修改插件配置
export const pluginSetConfig = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/plugin/plugin/setConfig'
    })
//短信账户信息
export const pluginUserInfo = () =>
    request({
        method: 'GET',
        url: 'plugin/sms/userInfo'
    })
//短信配置-短信模板
export const pluginTpList = () =>
    request({
        method: 'GET',
        url: '/plugin/sms/tplList'
    })
//提现管理-提现配置(选项数据)
export const withdrawConfig = () =>
    request({
        method: 'GET',
        url: '/member/withdraw/config'
    })
//提现管理-提现配置
export const withdrawSetConfig = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/withdraw/setConfig'
    })
//提现押金管理-白名单列表
export const withdrawWhiteList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/basis/withdrawWhite/list'
    })
//提现押金管理-搜索用户
export const withdrawWhiteSearch = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/basis/withdrawWhite/search'
    })
//提现押金管理-添加白名单
export const withdrawWhiteAdd = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/basis/withdrawWhite/add'
    })
//提现押金管理-白名单详情
export const withdrawWhiteInfo = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/basis/withdrawWhite/info'
    })
//提现押金管理-编辑白名单
export const withdrawWhiteSet = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/basis/withdrawWhite/set'
    })
//提现押金管理-删除白名单
export const withdrawWhiteDel = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/basis/withdrawWhite/del'
    })
//提现押金管理-修改状态
export const withdrawWhiteSetStatus = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/basis/withdrawWhite/setStatus'
    })


/*
* 俱乐部 -  审核
* */
//俱乐部- 审核 - 选项数据
export const clubValidateForm = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/validate/form_data'
    });
//俱乐部- 审核 - 列表
export const clubValidateList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/validate/list'
    })
//俱乐部- 审核 - 详情
export const clubValidateInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/validate/info'
    })
//俱乐部- 审核 - 操作
export const clubValidateCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/validate/check'
    })

/*
* 俱乐部 -  列表
* */
//俱乐部- 列表 - 搜索表单-选项数据
export const clubListFormData = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/list/form_data'
    });
//俱乐部- 列表 - 列表
export const clubListList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/list/list'
    })
//俱乐部- 列表 - 详情
export const clubListInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/list/info'
    })

/*
* 俱乐部 - 游戏服务 -  列表
* */

export const clubGameAdd = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/add'
    })
export const clubGameList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/game/list'
    })
export const clubGameInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/info'
    })
export const clubGameFormData = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/form_data'
    })
//俱乐部- 游戏服务 - 添加/修改
export const clubGameServeAdd = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/server_add'
    })
export const clubGameServeDel = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/server_del'
    })
export const clubGameServeList = (params: any) =>
    request({
        params,
        method: 'GET',
        url: '/club/game/server_list'
    })
export const clubGameFormDataServe = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/form_data_serve'
    })
export const clubGameServeInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/game/server_info'
    })
export const clubOpt = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/list/club_opt'
    })

export const get_game_list = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/get_game_list'
    })

//把普通用户设置为大神
export const user_set_ds = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/user_set_ds'
    })
export const user_set_ds_one = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/member/user_set_ds_one'
    })
//大神统计
export const dsTotal = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/dsTotal'
    })
//大神统计
export const bossTotal = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/bossTotal'
    })
//大神统计-特殊查询
export const dsTpTotalList = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/dsTpTotalList'
    })

//俱乐部-活动-添加
export const getClubActionOptions = (data: any) =>
    request({
        url: '/club/action/form_data',
        method: 'POST',
        data
    })
export const clubActionModify = (data: any) =>
    request({
        url: '/club/action/modify',
        method: 'POST',
        data
    });
//俱乐部-节日
export const clubFestivalModify = (data: any) =>
    request({
        url: '/club/action/festival_modify',
        method: 'POST',
        data
    });
export const clubFestivalAddressList = (data: any) =>
    request({
        url: '/club/action/festival_address_list',
        method: 'POST',
        data
    });
export const orderPDCalculate = (data: any) =>
    request({
        url: '/order/order/orderPDCalculate',
        method: 'POST',
        data
    });

//账号租售-表单数据
export const getAccountRsOptions = (data: any) =>
    request({
        url: '/club/action/account_rs_form_data',
        method: 'POST',
        data
    })
//账号租售-账号回收
export const getAccountRecycleList = (data: any) =>
    request({
        url: '/club/action/accountRecycleList',
        method: 'POST',
        data
    })
export const getAccountRecycleInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/account_recycle_info'
    })
export const updateAccountRecycleInfo = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/updateAccountRecycleInfo'
    })
export const wapOrderPriceList = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/wap_order_price_list'
    })
export const wapOrderPriceModify = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/wap_order_price_modify'
    })

export const bossRankHfbList = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/boss_rank_hfb_list'
    })

export const bossRankHfbCheck = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/boss_rank_hfb_modify'
    });
export const bossRankSend = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/boss_rank_hfb_send'
    });

export const bossRankHfbRank = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/boss_rank_hfb_rank'
    })

export const boss_code_list = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/club/action/boss_code_list'
    })

export const get_lottery_list = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/lotteryList'
    });
export const get_lottery_day_list = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/lotteryDayList'
    });
export const boss_lottery_send_reward = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/lotterySendReward'
    })
export const boss_lottery_upload_pay_code = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/lotteryUploadPayCode'
    })
export const get_lottery_day_detail = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/getLotteryDetail'
    })
export const boss_lottery_day_upload = (data: any) =>
    request({
        data,
        method: 'POST',
        url: '/order/lotteryDayUpload'
    })

//俱乐部-邀请用户-表单
export const invite_data = (data: any) =>
    request({
        url: '/club/action/invite_data',
        method: 'POST',
        data
    })
//俱乐部-邀请用户-大神列表
export const invite_ds_list = (data: any) =>
    request({
        url: '/club/action/invite_ds_list',
        method: 'POST',
        data
    })
//俱乐部-邀请用户-大神列表-审核
export const invite_ds_validate_status = (data: any) =>
    request({
        url: '/club/action/invite_ds_validate_status',
        method: 'POST',
        data
    });
//俱乐部-邀请用户-大神列表-重新生成海报
export const invite_ds_refresh_poster = (data: any) =>
    request({
        url: '/club/action/invite_ds_refresh_poster',
        method: 'POST',
        data
    });
//俱乐部-邀请用户-老板列表-审核
export const invite_bs_validate_status = (data: any) =>
    request({
        url: '/club/action/invite_bs_validate_status',
        method: 'POST',
        data
    });
//俱乐部-邀请用户-老板列表
export const invite_bs_list = (data: any) =>
    request({
        url: '/club/action/invite_bs_list',
        method: 'POST',
        data
    });
//俱乐部-邀请用户-消费列表
export const invite_expend_list = (data: any) =>
    request({
        url: '/club/action/invite_expend_list',
        method: 'POST',
        data
    });
//俱乐部-优惠券--列表
export const invite_coupon_list = (data: any) =>
    request({
        url: '/club/action/invite_coupon_list',
        method: 'POST',
        data
    });
//俱乐部-邀请用户-手动录入老板数据
export const invite_bs_info_modify = (data: any) =>
    request({
        url: '/club/action/invite_bs_info_modify',
        method: 'POST',
        data
    });
//俱乐部-大神-信誉分-表单
export const score_form_data = (data: any) =>
    request({
        url: '/club/action/score_form_data',
        method: 'POST',
        data
    })
//俱乐部-大神-信誉分-分类处理
export const score_category_modify = (data: any) =>
    request({
        url: '/club/action/score_category_modify',
        method: 'POST',
        data
    });
//俱乐部-大神-信誉分-处理
export const score_list_modify = (data: any) =>
    request({
        url: '/club/action/score_list_modify',
        method: 'POST',
        data
    });
//俱乐部-大神-信誉分-列表
export const score_list = (data: any) =>
    request({
        url: '/club/action/score_list',
        method: 'POST',
        data
    });

//俱乐部-获取老板数据
export const club_get_boss_info = (data: any) =>
    request({
        url: '/club/item/get_boss_info',
        method: 'POST',
        data
    });
//俱乐部-获取老板数据--筛选
export const club_get_boss_info_filter = (data: any) =>
    request({
        url: '/club/item/get_boss_info_filter',
        method: 'POST',
        data
    });
//俱乐部-获取老板数据--修改
export const boss_info_edit = (data: any) =>
    request({
        url: '/club/item/boss_info_edit',
        method: 'POST',
        data
    });

//俱乐部-获取老板--列表
export const get_boss_list = (data: any) =>
    request({
        url: '/club/item/get_boss_list',
        method: 'POST',
        data
    });

//俱乐部-小游戏-表单
export const clubMiniGameFormData = (data: any) => request({data, method: 'POST', url: '/club/game/mini_form_data'});
export const clubMiniGameList = (data: any) => request({data, method: 'POST', url: '/club/game/mini_list'});
export const clubMiniGameModify = (data: any) => request({data, method: 'POST', url: '/club/game/mini_modify'});
export const clubMiniGameCreateList = (data: any) => request({data, method: 'POST', url: '/club/game/mini_history'});
//跑刀
export const clubPdTagModify = (data: any) => request({data, method: 'POST', url: '/club/validate/pdTagModify'});
export const clubPdTagList = (data: any) => request({data, method: 'POST', url: '/club/validate/pdTagList'});

//重置-俱乐部-小游戏-表单
export const miniGameReset = (data: any) => request({data, method: 'POST', url: '/club/game/mini_game_reset'});
export const miniGameResetUser = (data: any) => request({data, method: 'POST', url: '/club/game/mini_game_reset_user'});
//俱乐部-小游戏-访客码-创建修改
export const miniGameGuestCode = (data: any) => request({data, method: 'POST', url: '/club/game/mini_game_guest_code'});
export const miniGameGuestList = (data: any) => request({data, method: 'POST', url: '/club/game/mini_game_guest_list'});
//获取跑刀统计
export const getPdTotal = (data: any) => request({data, method: 'POST', url: '/order/orderPDTotal'});
//交接文档-编辑
export const clubNoteModify = (data: any) => request({data, method: 'POST', url: '/club/validate/noteModify'});
export const clubNoteList = (data: any) => request({data, method: 'POST', url: '/club/validate/noteList'});

export const clubProductList = (data: any) => request({data, method: 'POST', url: '/club/action/product_list'});
export const clubProductModify = (data: any) => request({data, method: 'POST', url: '/club/action/product_modify'});

export const clubProductBanner = (data: any) => request({data, method: 'POST', url: '/club/action/product_banner_list'});
export const clubProductBannerModify = (data: any) => request({data, method: 'POST', url: '/club/action/product_banner_modify'});

// =============================================
// 记账与工作记录模块
// =============================================
//分类
export const accountWorkCategoryList = (data: any) => request({data, method: 'POST', url: '/club/account_work/category_list'});
export const accountWorkCategoryModify = (data: any) => request({data, method: 'POST', url: '/club/account_work/category_modify'});
//记账
export const accountFormData = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_form_data'});
export const accountList = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_list'});
export const accountModify = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_modify'});
export const accountInfo = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_info'});
export const accountUpdateStatus = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_update_status'});
export const accountAmountStats = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_amount_stats'});
export const accountAmountExport = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_amount_export'});
export const accountBatchReimburse = (data: any) => request({data, method: 'POST', url: '/club/account_work/account_batch_reimburse'});
//工作记录
export const workLogFormData = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_form_data'});
export const workLogList = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_list'});
export const workLogModify = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_modify'});
export const workLogInfo = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_info'});
export const workLogUpdateProgress = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_update_progress'});
export const workLogMarkComplete = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_mark_complete'});
export const workLogArchive = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_archive'});
export const workLogDelete = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_delete'});
export const workLogUserList = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_user_list'});
export const workLogTodoList = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_todo_list'});
export const workLogTodoUpdate = (data: any) => request({data, method: 'POST', url: '/club/account_work/work_log_todo_update'});

//酒店管理
export const hotelList = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_list'});
export const hotelMyList = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_my_list'});
export const hotelModify = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_modify'});
export const hotelInfo = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_info'});
export const hotelOrderList = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_order_list'});
export const hotelOrderTrend = (data: any) => request({data, method: 'POST', url: '/club/hotel/hotel_order_trend'});
export const hotelAccountList = (data: any) => request({data, method: 'POST', url: '/club/hotel/account_list'});
export const hotelAccountModify = (data: any) => request({data, method: 'POST', url: '/club/hotel/account_modify'});
export const hotelAccountResetPassword = (data: any) => request({data, method: 'POST', url: '/club/hotel/account_reset_password'});
export const hotelAccountSetStatus = (data: any) => request({data, method: 'POST', url: '/club/hotel/account_set_status'});
export const hotelLoginRecord = (data: any) => request({data, method: 'POST', url: '/club/hotel/account_login_record'});
export const qrcodeMaterialOptions = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_material_options'});
export const settlementList = (data: any) => request({data, method: 'POST', url: '/club/hotel/settlement_list'});
export const settlementStatistics = (data: any) => request({data, method: 'POST', url: '/club/hotel/settlement_statistics'});
export const settlementConfirm = (data: any) => request({data, method: 'POST', url: '/club/hotel/settlement_confirm'});
export const qrcodeList = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_list'});
export const qrcodeStatistics = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_statistics'});
export const qrcodeModify = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_modify'});
export const qrcodeSetStatus = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_set_status'});
export const cityList = (data: any) => request({data, method: 'POST', url: '/club/hotel/city_list'});
export const cityModify = (data: any) => request({data, method: 'POST', url: '/club/hotel/city_modify'});
export const citySetStatus = (data: any) => request({data, method: 'POST', url: '/club/hotel/city_set_status'});
export const qrcodeDataDetail = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_data_detail'});
export const qrcodeScanLog = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_scan_log'});
export const qrcodeScanTrend = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_scan_trend'});
export const qrcodeBindList = (data: any) => request({data, method: 'POST', url: '/club/hotel/qrcode_bind_list'});

// =============================================
// 广告商(adsense)管理模块
// =============================================
export const adsenseFormData = (data: any) => request({data, method: 'POST', url: '/club/adsense/form_data'});
export const adsenseClubList = (data: any) => request({data, method: 'POST', url: '/club/adsense/club_list'});
export const adsenseClubInfo = (data: any) => request({data, method: 'POST', url: '/club/adsense/club_info'});
export const adsenseClubStatus = (data: any) => request({data, method: 'POST', url: '/club/adsense/club_status'});
export const adsenseUserList = (data: any) => request({data, method: 'POST', url: '/club/adsense/user_list'});
export const adsenseUserModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/user_modify'});
export const adsenseVerifyList = (data: any) => request({data, method: 'POST', url: '/club/adsense/verify_list'});
export const adsenseVerifyAudit = (data: any) => request({data, method: 'POST', url: '/club/adsense/verify_audit'});
export const adsenseProductList = (data: any) => request({data, method: 'POST', url: '/club/adsense/product_list'});
export const adsenseProductModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/product_modify'});
export const adsenseUrlList = (data: any) => request({data, method: 'POST', url: '/club/adsense/url_list'});
export const adsenseUrlModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/url_modify'});
export const adsenseKfList = (data: any) => request({data, method: 'POST', url: '/club/adsense/kf_list'});
export const adsenseKfModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/kf_modify'});
export const adsenseBannerList = (data: any) => request({data, method: 'POST', url: '/club/adsense/banner_list'});
export const adsenseBannerModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/banner_modify'});
export const adsenseLogList = (data: any) => request({data, method: 'POST', url: '/club/adsense/log_list'});
export const adsenseLogFormData = (data: any) => request({data, method: 'POST', url: '/club/adsense/log_form_data'});
export const adsenseUrlVisitLog = (data: any) => request({data, method: 'POST', url: '/club/adsense/url_visit_log'});
export const adsenseIconList = (data: any) => request({data, method: 'POST', url: '/club/adsense/icon_list'});
export const adsenseIconModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/icon_modify'});
export const adsenseBadgeList = (data: any) => request({data, method: 'POST', url: '/club/adsense/badge_list'});
export const adsenseBadgeModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/badge_modify'});
export const adsenseBannerResourceList = (data: any) => request({data, method: 'POST', url: '/club/adsense/banner_resource_list'});
export const adsenseBannerResourceModify = (data: any) => request({data, method: 'POST', url: '/club/adsense/banner_resource_modify'});

// 发布量与VIP管理
export const publishLimitList = (data: any) => request({data, method: 'POST', url: '/club/publish/limit_list'});
export const publishLimitSave = (data: any) => request({data, method: 'POST', url: '/club/publish/limit_save'});
export const publishStatsRebuild = (data: any) => request({data, method: 'POST', url: '/club/publish/stats_rebuild'});
export const publishVipTypeList = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_type_list'});
export const publishVipTypeModify = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_type_modify'});
export const publishVipTypeDelete = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_type_delete'});
export const publishVipOrderList = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_order_list'});
export const publishVipOrderRename = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_order_rename'});
export const publishSubscriptionList = (data: any) => request({data, method: 'POST', url: '/club/publish/subscription_list'});
export const customerUserList = (data: any) => request({data, method: 'POST', url: '/club/customer_user/list'});
export const customerUserInfo = (data: any) => request({data, method: 'POST', url: '/club/customer_user/info'});
// 手机号查询：跨商户精确检索平台会员/商户员工/陪玩子账号/租号子账号四类身份
export const customerPhoneList = (data: any) => request({data, method: 'POST', url: '/club/customer_phone/list'});
export const customerPhoneDetail = (data: any) => request({data, method: 'POST', url: '/club/customer_phone/detail'});
// 老板/大神详情抽屉（平台端只读，同一权限节点 ClubCustomerUserBoss，按 view 分流）
export const customerBossInfo = (data: any) => request({data: {...data, view:'boss'}, method: 'POST', url: '/club/customer_user/boss'});
export const customerBossOrders = (data: any) => request({data: {...data, view:'boss_orders'}, method: 'POST', url: '/club/customer_user/boss'});
export const customerBossRecharge = (data: any) => request({data: {...data, view:'boss_recharge'}, method: 'POST', url: '/club/customer_user/boss'});
// 大神接单记录 / 资金日志（只读，复用商户端 GpService，锁定本商户该大神）
export const customerProOrders = (data: any) => request({data: {...data, view:'pro_orders'}, method: 'POST', url: '/club/customer_user/boss'});
export const customerProFundLog = (data: any) => request({data: {...data, view:'pro_fund_log'}, method: 'POST', url: '/club/customer_user/boss'});
export const customerFollowupRead = (data: any) => request({data, method: 'POST', url: '/club/customer_followup/read'});
export const customerFollowupSave = (data: any) => request({data, method: 'POST', url: '/club/customer_followup/save'});
export const customerFeedbackRead = (data: any) => request({data, method: 'POST', url: '/club/customer_feedback/read'});
export const customerFeedbackSave = (data: any) => request({data, method: 'POST', url: '/club/customer_feedback/save'});
export const customerAnalyticsRead = (data: any) => request({data, method: 'POST', url: '/club/customer_analytics/read'});
export const customerClassificationRead = (data: any) => request({data, method:'POST', url:'/club/customer_classification/read'});
export const customerClassificationSave = (data: any) => request({data, method:'POST', url:'/club/customer_classification/save'});
// 客户业务日志(跨商户只读汇总)：商户订单/资金日志/商户操作日志/提现日志
export const customerOrderList = (data: any) => request({data, method: 'POST', url: '/club/customer_order/list'});
// gp 订单只读详情：走 list 接口的 view=detail 分支，复用 ClubCustomerOrderList 权限。
export const customerOrderDetail = (data: any) => request({data: {...data, view: 'detail'}, method: 'POST', url: '/club/customer_order/list'});
export const customerFundLogList = (data: any) => request({data, method: 'POST', url: '/club/customer_fund_log/list'});
export const customerOperationLogList = (data: any) => request({data, method: 'POST', url: '/club/customer_operation_log/list'});
export const customerCashList = (data: any) => request({data, method: 'POST', url: '/club/customer_cash/list'});
export const merchantLogoutList = (data: any) => request({data, method: 'POST', url: '/club/merchant_logout/list'});
export const merchantLogoutAudit = (data: any) => request({data, method: 'POST', url: '/club/merchant_logout/audit'});
export const merchantLogoutRevoke = (data: any) => request({data, method: 'POST', url: '/club/merchant_logout/revoke'});
export const customerProfileRead = (data:any)=>request({data,method:'POST',url:'/club/customer_profile/read'});
export const customerProfileSave = (data:any)=>request({data,method:'POST',url:'/club/customer_profile/save'});
export const customerLinkRead = (data:any)=>request({data,method:'POST',url:'/club/customer_link/read'});
export const customerLinkProductSave = (data:any)=>request({data,method:'POST',url:'/club/customer_link/product_save'});
export const customerLinkUserSave = (data:any)=>request({data,method:'POST',url:'/club/customer_link/user_save'});
export const customerUserProfileRead = (data:any)=>request({data,method:'POST',url:'/club/customer_profile/user_info'});
export const customerUserProfileSave = (data:any)=>request({data,method:'POST',url:'/club/customer_profile/user_save'});
export const publishVipOrderOpen = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_order_open'});
export const publishVipFormData = (data: any) => request({data, method: 'POST', url: '/club/publish/vip_form_data'});
export const publishMerchantSearch = (data: any) => request({data, method: 'POST', url: '/club/publish/merchant_search'});

// 资金交易记录 - 选项数据 - 员工
export const getTradeLogsFromEmployee = (params?: any) =>
    request({
        url: "/trade/amount/logsFormEmployee",
        method: "get",
        params
    });
export const getTradeLogsEmployee = (params?: any) =>
    request({
        url: "/trade/amount/logsEmployee",
        method: "get",
        params
    });
// =============================================
// 商户自定义域名绑定(ESA SaaS) 管理
// =============================================
export const merchantDomainList = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/list'});
export const merchantDomainDetail = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/detail'});
export const merchantDomainSync = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/sync'});
export const merchantDomainAudit = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/audit'});
export const merchantDomainEnable = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/enable'});
export const merchantDomainUnbind = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/unbind'});
export const merchantDomainAdd = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/add'});
export const merchantDomainReconcile = (data: any) => request({data, method: 'POST', url: '/club/merchantDomain/reconcile'});

// =============================================
// 平台参数配置(we_sys_setting)：ESA 域名服务参数
// =============================================
export const sysSettingEsa = () => request({url: '/basis/sysSetting/esa', method: 'get'});
export const sysSettingEsaSet = (data: any) => request({data, method: 'POST', url: '/basis/sysSetting/esaSet'});
export const sysSettingEsaTest = (data: any) => request({data, method: 'POST', url: '/basis/sysSetting/esaTest'});

// =============================================
// 商户直连收款凭据管理
// 商户端配置(club/adsense/pay_config_*)仅主账号可用，这里负责平台侧查看/代配/强制停用。
// 详情接口对敏感字段只回掩码，平台人员同样是「只写不可读」。
// =============================================
export const merchantPayConfigList = (data: any) => request({data, method: 'POST', url: '/club/merchantPayConfig/list'});
export const merchantPayConfigDetail = (data: any) => request({data, method: 'POST', url: '/club/merchantPayConfig/detail'});
export const merchantPayConfigSet = (data: any) => request({data, method: 'POST', url: '/club/merchantPayConfig/set'});
export const merchantPayConfigVerify = (data: any) => request({data, method: 'POST', url: '/club/merchantPayConfig/verify'});
export const merchantPayConfigEnable = (data: any) => request({data, method: 'POST', url: '/club/merchantPayConfig/enable'});

// =============================================
// 平台经营配置(平台自营收款凭据)
// 微信商户号/支付宝应用凭据存 we_platform_pay_config，与商户直连收款是两套。
// 敏感字段(API密钥、私钥)保存后任何接口都不回显原文，留空=不修改。
// 提现不走这里 —— 它仍读 we_plugin 的 alipay_transfer / 微信转账凭据。
// =============================================
export const platformPayConfigInfo = () => request({url: '/club/platformPayConfig/info', method: 'get'});
export const platformPayConfigSave = (data: any) => request({data, method: 'POST', url: '/club/platformPayConfig/save'});
export const platformPayConfigVerify = (data: any) => request({data, method: 'POST', url: '/club/platformPayConfig/verify'});
export const platformPayConfigEnable = (data: any) => request({data, method: 'POST', url: '/club/platformPayConfig/enable'});

// =============================================
// 商户灰度名单(域名绑定/服务号授权域名/直连收款)
// 取代 api/config/white.php 里的三个 *_mid 数组；白名单制，名单为空=谁都不开放。
// 一份接口服务两个页面：type 1=域名白名单 2=服务号授权域名 3=收款白名单。
// =============================================
export const merchantGrayListList = (data: any) => request({data, method: 'POST', url: '/club/merchantGrayList/list'});
export const merchantGrayListSearch = (data: any) => request({data, method: 'POST', url: '/club/merchantGrayList/search'});
export const merchantGrayListAdd = (data: any) => request({data, method: 'POST', url: '/club/merchantGrayList/add'});
export const merchantGrayListDelete = (data: any) => request({data, method: 'POST', url: '/club/merchantGrayList/delete'});
// =============================================
// GP 实名管理（腾讯云人脸核身）
// =============================================
export const gpFaceAdminSettingInfo = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/setting_info'});
export const gpFaceAdminSettingSave = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/setting_save'});
export const gpFaceAdminPackageList = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/package_list'});
export const gpFaceAdminPackageModify = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/package_modify'});
export const gpFaceAdminPackageDelete = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/package_delete'});
export const gpFaceAdminMerchantList = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/merchant_list'});
export const gpFaceAdminMerchantSave = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/merchant_save'});
export const gpFaceAdminMerchantAdjust = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/merchant_adjust'});
export const gpFaceAdminFundLog = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/fund_log'});
export const gpFaceAdminUseList = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/use_list'});
export const gpFaceAdminOrderList = (data: any) => request({data, method: 'POST', url: '/club/gpFaceAdmin/order_list'});
